<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("consentform.detail") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title> {{ HeaderConsent }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11 pb-3>
                    <b>{{ $t("consentform.organ") }} : </b> <br />
                    <div v-if="$t('default') === 'th'">
                      {{ BusinessNameTh }}
                    </div>
                    <div v-else>
                      {{ BusinessNameEng }}
                    </div>
                  </v-flex>
                  <v-flex xs11 lg11 pb-3>
                    <b>{{ $t("consentform.create") }} :</b> <br />
                    <div v-if="$t('default') === 'th'">
                      {{ UpdatdeBy }}
                    </div>
                    <div v-else>
                      {{ UpdatdeByEng }}
                    </div>
                  </v-flex>
                  <v-flex xs11 lg5 pb-3>
                    <b>{{ $t("consentform.age") }} :</b> <br />
                    {{ ExpireIn }} {{ $t("consentform.age2") }}
                  </v-flex>
                  <v-flex xs11 lg6 pb-3>
                    <b>{{ $t("consentform.brief") }} :</b> <br />
                    {{ ShortConsent }}
                  </v-flex>
                  <v-flex xs11 lg11 pb-3>
                    <b v-if="$t('default') === 'th'">ข้อมูลที่ต้องการขอ :</b>
                    <b v-else>Personal Data to Request :</b>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-chip
                          small
                          style="border: 1px solid"
                          v-for="(item, i) in itemsRequest"
                          :key="i"
                          class="ma-1"
                          label
                          text-color="#077893"
                          color="#ddf7ff"
                        >
                          <b>{{ item }}</b>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex xs11 lg11 pb-3>
                    <b v-if="$t('default') === 'th'">TagSource :</b>
                    <b v-else>Personal Data to Request :</b>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-chip
                          small
                          style="border: 1px solid"
                          v-for="(item, i) in itemsRequestTag"
                          :key="i"
                          class="ma-1"
                          label
                          text-color="#077893"
                          color="#ddf7ff"
                        >
                          <b>{{ item }}</b>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("consentform.detail") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap pa-2>
                  <v-flex xs11 lg11>
                    <div v-html="DetailConsent"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5 pb-10>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("consentform.agree") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap pa-2>
                  <v-flex xs11 lg11>
                    <div v-html="RejectReason"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      HeaderConsent: "",
      DetailTitle: "",
      DetailConsent: "",
      RejectReason: "",
      BusinessNameTh: "",
      UpdatdeBy: "",
      UpdatdeByEng: "",
      ExpireIn: "",
      ShortConsent: "",
      loadingDownloadData: false,
      itemsRequest: [],
      itemsRequestTag: [],
    };
  },
  computed: {
    ...mapGetters(["DataConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _ConsentId: {
      get() {
        return this.DataConsent.ConsentId || "-";
      },
    },
  },
  mounted() {
    this.fn_getDataConsent();
  },
  methods: {
    async fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        ConsentId: this._ConsentId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.GetDataConsent = response.data.Message;
            this.HeaderConsent = response.data.Message[0].HeaderConsent;
            this.DetailConsent = response.data.Message[0].DetailsConsent;
            this.RejectReason = response.data.Message[0].RejectReason;
            this.BusinessNameTh = response.data.Message[0].BusinessNameTh;
            this.BusinessNameEng = response.data.Message[0].BusinessNameEng;
            this.UpdatdeBy = response.data.Message[0].UpdatdeBy;
            this.UpdatdeByEng = response.data.Message[0].UpdatdeByEng;
            this.ExpireIn = response.data.Message[0].ExpireIn;
            this.ShortConsent = response.data.Message[0].ShortConsent;
            // this.itemsRequest = response.data.Message[0].Tag;
            var FixArray = response.data.Message[0].Tag;
            if (FixArray == "") {
            } else {
              // FixArray = JSON.parse(FixArray.replace(/'/g, '"'));
              this.itemsRequest = FixArray.split(",").map((item) =>
                item.trim()
              );
            }
            var FixArrayTag = response.data.Message[0].TagSource;
            if (FixArrayTag == "") {
            } else {
              this.itemsRequestTag = FixArrayTag.split(",").map((item) =>
                item.trim()
              );
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/consent-index");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

b.style {
  border-style: solid;
  border-color: #077893;
  border-width: 1px;
}
</style>
